<template>
<div class="chapter">
<div class="inner_page">
<div id="Halftitle">
<div class="half-title"><a id="page_1"><b>ATLAS</b></a></div><a id="page_1">
<div class="half-title1">of</div>
<div class="half-title2"><b>EXTRATERRESTRIAL ZONES</b></div>
</a></div><a id="page_1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Halftitle.vue?c7876fe4